// Feature flags — surfaces built and kept whole, but not shown in this
// release. One flag, one owner call, one place to flip it.
//
// HUSTLE IS RETIRED (owner call, 2026-10-07: "Retired: remove it"). It hid
// behind a flag here from 2026-08-28; its screens, flag and specs are gone
// from the web, and /hustle lands on Skills. The server routes the iPhone app
// and Paradigm's scheduler call stay (docs/AUTOMATIONS.md).

// CAPTURE IS RELEASED (owner call, 2026-09-24). Its schemas and Personas
// callback are live. Navigation, the tour, checklist and Aspire links use
// this same default; an explicit browser override can still hide it.
//
//   localStorage.setItem('kalibrCaptureEnabled', 'false')   // then reload
export function captureEnabled(): boolean {
  try {
    return localStorage.getItem('kalibrCaptureEnabled') !== 'false';
  } catch {
    return true;
  }
}
export const CAPTURE_ENABLED: boolean = captureEnabled();
